// 该文件由 tools/gen_mock_data.py 自动生成，请勿手动修改。
// 数据来源：src/assets/Case 目录下的本地案例图片。
// 重新生成：在项目根目录执行 python tools/gen_mock_data.py

// 每条案例对应后端 t_ytmt 表的一条记录，字段与真实接口保持一致：
//   id / type / name / location / date / router / content / img
// 其中 img 为多张图片地址用英文分号 ";" 拼接（本地模式下为 webpack 处理后的图片 URL）

// @ts-ignore
const mockCases = [
  {
    id: 1,
    type: 1,
    name: "游艇码头项目01",
    location: "中国",
    date: "2017-02-15",
    router: "游艇码头",
    content: "游艇码头项目01，位于中国，2017-02-15建成投用。本项目由专业团队完成整体设计、生产与水上施工，主体采用模块化浮体结构，可根据水域条件灵活组合布置，具备抗风浪、耐腐蚀、免维护等特点，交付后运行稳定，获得客户认可。",
    img: ""
  },
  {
    id: 2,
    type: 1,
    name: "游艇码头项目02",
    location: "中国",
    date: "2018-03-15",
    router: "游艇码头",
    content: "游艇码头项目02，位于中国，2018-03-15建成投用。本项目由专业团队完成整体设计、生产与水上施工，主体采用模块化浮体结构，可根据水域条件灵活组合布置，具备抗风浪、耐腐蚀、免维护等特点，交付后运行稳定，获得客户认可。",
    img: ""
  },
  {
    id: 3,
    type: 1,
    name: "游艇码头项目03",
    location: "中国",
    date: "2019-04-15",
    router: "游艇码头",
    content: "游艇码头项目03，位于中国，2019-04-15建成投用。本项目由专业团队完成整体设计、生产与水上施工，主体采用模块化浮体结构，可根据水域条件灵活组合布置，具备抗风浪、耐腐蚀、免维护等特点，交付后运行稳定，获得客户认可。",
    img: ""
  },
  {
    id: 4,
    type: 1,
    name: "游艇码头项目04",
    location: "中国",
    date: "2020-05-15",
    router: "游艇码头",
    content: "游艇码头项目04，位于中国，2020-05-15建成投用。本项目由专业团队完成整体设计、生产与水上施工，主体采用模块化浮体结构，可根据水域条件灵活组合布置，具备抗风浪、耐腐蚀、免维护等特点，交付后运行稳定，获得客户认可。",
    img: ""
  },
  {
    id: 5,
    type: 1,
    name: "游艇码头项目05",
    location: "中国",
    date: "2021-06-15",
    router: "游艇码头",
    content: "游艇码头项目05，位于中国，2021-06-15建成投用。本项目由专业团队完成整体设计、生产与水上施工，主体采用模块化浮体结构，可根据水域条件灵活组合布置，具备抗风浪、耐腐蚀、免维护等特点，交付后运行稳定，获得客户认可。",
    img: ""
  },
  {
    id: 6,
    type: 1,
    name: "游艇码头项目06",
    location: "中国",
    date: "2016-07-15",
    router: "游艇码头",
    content: "游艇码头项目06，位于中国，2016-07-15建成投用。本项目由专业团队完成整体设计、生产与水上施工，主体采用模块化浮体结构，可根据水域条件灵活组合布置，具备抗风浪、耐腐蚀、免维护等特点，交付后运行稳定，获得客户认可。",
    img: ""
  },
  {
    id: 7,
    type: 1,
    name: "游艇码头项目07",
    location: "中国",
    date: "2017-08-15",
    router: "游艇码头",
    content: "游艇码头项目07，位于中国，2017-08-15建成投用。本项目由专业团队完成整体设计、生产与水上施工，主体采用模块化浮体结构，可根据水域条件灵活组合布置，具备抗风浪、耐腐蚀、免维护等特点，交付后运行稳定，获得客户认可。",
    img: ""
  },
  {
    id: 8,
    type: 1,
    name: "游艇码头项目08",
    location: "中国",
    date: "2018-09-15",
    router: "游艇码头",
    content: "游艇码头项目08，位于中国，2018-09-15建成投用。本项目由专业团队完成整体设计、生产与水上施工，主体采用模块化浮体结构，可根据水域条件灵活组合布置，具备抗风浪、耐腐蚀、免维护等特点，交付后运行稳定，获得客户认可。",
    img: ""
  },
  {
    id: 9,
    type: 1,
    name: "游艇码头项目09",
    location: "中国",
    date: "2019-10-15",
    router: "游艇码头",
    content: "游艇码头项目09，位于中国，2019-10-15建成投用。本项目由专业团队完成整体设计、生产与水上施工，主体采用模块化浮体结构，可根据水域条件灵活组合布置，具备抗风浪、耐腐蚀、免维护等特点，交付后运行稳定，获得客户认可。",
    img: ""
  },
  {
    id: 10,
    type: 2,
    name: "塑料浮筒项目01",
    location: "中国",
    date: "2017-02-15",
    router: "塑料浮筒",
    content: "塑料浮筒项目01，位于中国，2017-02-15建成投用。本项目由专业团队完成整体设计、生产与水上施工，主体采用模块化浮体结构，可根据水域条件灵活组合布置，具备抗风浪、耐腐蚀、免维护等特点，交付后运行稳定，获得客户认可。",
    img: ""
  },
  {
    id: 11,
    type: 2,
    name: "塑料浮筒项目02",
    location: "中国",
    date: "2018-03-15",
    router: "塑料浮筒",
    content: "塑料浮筒项目02，位于中国，2018-03-15建成投用。本项目由专业团队完成整体设计、生产与水上施工，主体采用模块化浮体结构，可根据水域条件灵活组合布置，具备抗风浪、耐腐蚀、免维护等特点，交付后运行稳定，获得客户认可。",
    img: ""
  },
  {
    id: 12,
    type: 2,
    name: "福建漳州 浮桥平台450平米",
    location: "福建",
    date: "2021-05-01",
    router: "塑料浮筒",
    content: "福建漳州 浮桥平台450平米，位于福建，2021-05-01建成投用。本项目由专业团队完成整体设计、生产与水上施工，主体采用模块化浮体结构，可根据水域条件灵活组合布置，具备抗风浪、耐腐蚀、免维护等特点，交付后运行稳定，获得客户认可。",
    img: ""
  },
  {
    id: 13,
    type: 2,
    name: "印度水上酒店-2500平方",
    location: "印度",
    date: "2016-10-01",
    router: "塑料浮筒",
    content: "印度水上酒店-2500平方，位于印度，2016-10-01建成投用。本项目由专业团队完成整体设计、生产与水上施工，主体采用模块化浮体结构，可根据水域条件灵活组合布置，具备抗风浪、耐腐蚀、免维护等特点，交付后运行稳定，获得客户认可。",
    img: ""
  },
  {
    id: 14,
    type: 2,
    name: "英国抽水平台-220平方",
    location: "英国",
    date: "2021-06-01",
    router: "塑料浮筒",
    content: "英国抽水平台-220平方，位于英国，2021-06-01建成投用。本项目由专业团队完成整体设计、生产与水上施工，主体采用模块化浮体结构，可根据水域条件灵活组合布置，具备抗风浪、耐腐蚀、免维护等特点，交付后运行稳定，获得客户认可。",
    img: ""
  },
  {
    id: 15,
    type: 3,
    name: "船艇泊位项目01",
    location: "中国",
    date: "2017-02-15",
    router: "船艇泊位",
    content: "船艇泊位项目01，位于中国，2017-02-15建成投用。本项目由专业团队完成整体设计、生产与水上施工，主体采用模块化浮体结构，可根据水域条件灵活组合布置，具备抗风浪、耐腐蚀、免维护等特点，交付后运行稳定，获得客户认可。",
    img: ""
  },
  {
    id: 16,
    type: 3,
    name: "船艇泊位项目02",
    location: "中国",
    date: "2018-03-15",
    router: "船艇泊位",
    content: "船艇泊位项目02，位于中国，2018-03-15建成投用。本项目由专业团队完成整体设计、生产与水上施工，主体采用模块化浮体结构，可根据水域条件灵活组合布置，具备抗风浪、耐腐蚀、免维护等特点，交付后运行稳定，获得客户认可。",
    img: ""
  },
  {
    id: 17,
    type: 3,
    name: "深圳大鹏新区8组Ｖ型摩托艇码头36平方",
    location: "深圳",
    date: "2019-08-01",
    router: "船艇泊位",
    content: "深圳大鹏新区8组Ｖ型摩托艇码头36平方，位于深圳，2019-08-01建成投用。本项目由专业团队完成整体设计、生产与水上施工，主体采用模块化浮体结构，可根据水域条件灵活组合布置，具备抗风浪、耐腐蚀、免维护等特点，交付后运行稳定，获得客户认可。",
    img: ""
  },
  {
    id: 18,
    type: 3,
    name: "英国黑色快艇泊位",
    location: "英国",
    date: "2019-05-01",
    router: "船艇泊位",
    content: "英国黑色快艇泊位，位于英国，2019-05-01建成投用。本项目由专业团队完成整体设计、生产与水上施工，主体采用模块化浮体结构，可根据水域条件灵活组合布置，具备抗风浪、耐腐蚀、免维护等特点，交付后运行稳定，获得客户认可。",
    img: ""
  },
  {
    id: 19,
    type: 3,
    name: "荷兰滚轮浮筒快艇码头",
    location: "荷兰",
    date: "2020-01-01",
    router: "船艇泊位",
    content: "荷兰滚轮浮筒快艇码头，位于荷兰，2020-01-01建成投用。本项目由专业团队完成整体设计、生产与水上施工，主体采用模块化浮体结构，可根据水域条件灵活组合布置，具备抗风浪、耐腐蚀、免维护等特点，交付后运行稳定，获得客户认可。",
    img: ""
  },
  {
    id: 20,
    type: 3,
    name: "英国滚轮快艇码头",
    location: "英国",
    date: "2020-02-01",
    router: "船艇泊位",
    content: "英国滚轮快艇码头，位于英国，2020-02-01建成投用。本项目由专业团队完成整体设计、生产与水上施工，主体采用模块化浮体结构，可根据水域条件灵活组合布置，具备抗风浪、耐腐蚀、免维护等特点，交付后运行稳定，获得客户认可。",
    img: ""
  },
  {
    id: 21,
    type: 3,
    name: "迪拜快艇码头",
    location: "迪拜",
    date: "2020-05-01",
    router: "船艇泊位",
    content: "迪拜快艇码头，位于迪拜，2020-05-01建成投用。本项目由专业团队完成整体设计、生产与水上施工，主体采用模块化浮体结构，可根据水域条件灵活组合布置，具备抗风浪、耐腐蚀、免维护等特点，交付后运行稳定，获得客户认可。",
    img: ""
  },
  {
    id: 22,
    type: 3,
    name: "澳大利亚Tom快艇码头",
    location: "澳大利亚",
    date: "2020-06-01",
    router: "船艇泊位",
    content: "澳大利亚Tom快艇码头，位于澳大利亚，2020-06-01建成投用。本项目由专业团队完成整体设计、生产与水上施工，主体采用模块化浮体结构，可根据水域条件灵活组合布置，具备抗风浪、耐腐蚀、免维护等特点，交付后运行稳定，获得客户认可。",
    img: ""
  },
  {
    id: 23,
    type: 4,
    name: "光伏浮筒项目01",
    location: "中国",
    date: "2017-02-15",
    router: "光伏浮筒",
    content: "光伏浮筒项目01，位于中国，2017-02-15建成投用。本项目由专业团队完成整体设计、生产与水上施工，主体采用模块化浮体结构，可根据水域条件灵活组合布置，具备抗风浪、耐腐蚀、免维护等特点，交付后运行稳定，获得客户认可。",
    img: ""
  },
  {
    id: 24,
    type: 4,
    name: "光伏浮筒项目02",
    location: "中国",
    date: "2018-03-15",
    router: "光伏浮筒",
    content: "光伏浮筒项目02，位于中国，2018-03-15建成投用。本项目由专业团队完成整体设计、生产与水上施工，主体采用模块化浮体结构，可根据水域条件灵活组合布置，具备抗风浪、耐腐蚀、免维护等特点，交付后运行稳定，获得客户认可。",
    img: ""
  },
  {
    id: 25,
    type: 5,
    name: "防浪堤项目01",
    location: "中国",
    date: "2017-02-15",
    router: "防浪堤",
    content: "防浪堤项目01，位于中国，2017-02-15建成投用。本项目由专业团队完成整体设计、生产与水上施工，主体采用模块化浮体结构，可根据水域条件灵活组合布置，具备抗风浪、耐腐蚀、免维护等特点，交付后运行稳定，获得客户认可。",
    img: ""
  },
  {
    id: 26,
    type: 5,
    name: "防浪堤项目02",
    location: "中国",
    date: "2018-03-15",
    router: "防浪堤",
    content: "防浪堤项目02，位于中国，2018-03-15建成投用。本项目由专业团队完成整体设计、生产与水上施工，主体采用模块化浮体结构，可根据水域条件灵活组合布置，具备抗风浪、耐腐蚀、免维护等特点，交付后运行稳定，获得客户认可。",
    img: ""
  },
  {
    id: 27,
    type: 5,
    name: "卡塔尔防浪带",
    location: "卡塔尔",
    date: "2020-01-01",
    router: "防浪堤",
    content: "卡塔尔防浪带，位于卡塔尔，2020-01-01建成投用。本项目由专业团队完成整体设计、生产与水上施工，主体采用模块化浮体结构，可根据水域条件灵活组合布置，具备抗风浪、耐腐蚀、免维护等特点，交付后运行稳定，获得客户认可。",
    img: ""
  },
  {
    id: 28,
    type: 6,
    name: "海洋渔排项目01",
    location: "中国",
    date: "2017-02-15",
    router: "海洋渔排",
    content: "海洋渔排项目01，位于中国，2017-02-15建成投用。本项目由专业团队完成整体设计、生产与水上施工，主体采用模块化浮体结构，可根据水域条件灵活组合布置，具备抗风浪、耐腐蚀、免维护等特点，交付后运行稳定，获得客户认可。",
    img: ""
  },
  {
    id: 29,
    type: 6,
    name: "海洋渔排项目02",
    location: "中国",
    date: "2018-03-15",
    router: "海洋渔排",
    content: "海洋渔排项目02，位于中国，2018-03-15建成投用。本项目由专业团队完成整体设计、生产与水上施工，主体采用模块化浮体结构，可根据水域条件灵活组合布置，具备抗风浪、耐腐蚀、免维护等特点，交付后运行稳定，获得客户认可。",
    img: ""
  },
  {
    id: 30,
    type: 6,
    name: "江西萍乡 钓虾网箱",
    location: "江西",
    date: "2019-04-01",
    router: "海洋渔排",
    content: "江西萍乡 钓虾网箱，位于江西，2019-04-01建成投用。本项目由专业团队完成整体设计、生产与水上施工，主体采用模块化浮体结构，可根据水域条件灵活组合布置，具备抗风浪、耐腐蚀、免维护等特点，交付后运行稳定，获得客户认可。",
    img: ""
  },
  {
    id: 31,
    type: 6,
    name: "湖北十堰 钓鱼比赛码头",
    location: "湖北",
    date: "2019-05-01",
    router: "海洋渔排",
    content: "湖北十堰 钓鱼比赛码头，位于湖北，2019-05-01建成投用。本项目由专业团队完成整体设计、生产与水上施工，主体采用模块化浮体结构，可根据水域条件灵活组合布置，具备抗风浪、耐腐蚀、免维护等特点，交付后运行稳定，获得客户认可。",
    img: ""
  },
  {
    id: 32,
    type: 6,
    name: "广东清远 网箱养殖",
    location: "清远",
    date: "2019-12-01",
    router: "海洋渔排",
    content: "广东清远 网箱养殖，位于清远，2019-12-01建成投用。本项目由专业团队完成整体设计、生产与水上施工，主体采用模块化浮体结构，可根据水域条件灵活组合布置，具备抗风浪、耐腐蚀、免维护等特点，交付后运行稳定，获得客户认可。",
    img: ""
  },
  {
    id: 33,
    type: 6,
    name: "江西抚州 网箱养殖350平米",
    location: "江西",
    date: "2020-03-01",
    router: "海洋渔排",
    content: "江西抚州 网箱养殖350平米，位于江西，2020-03-01建成投用。本项目由专业团队完成整体设计、生产与水上施工，主体采用模块化浮体结构，可根据水域条件灵活组合布置，具备抗风浪、耐腐蚀、免维护等特点，交付后运行稳定，获得客户认可。",
    img: ""
  },
  {
    id: 34,
    type: 6,
    name: "佛山三水农庄网箱平台40平方",
    location: "佛山",
    date: "2021-07-21",
    router: "海洋渔排",
    content: "佛山三水农庄网箱平台40平方，位于佛山，2021-07-21建成投用。本项目由专业团队完成整体设计、生产与水上施工，主体采用模块化浮体结构，可根据水域条件灵活组合布置，具备抗风浪、耐腐蚀、免维护等特点，交付后运行稳定，获得客户认可。",
    img: ""
  },
]

export default mockCases
